import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import { PoliceStationForm } from "app/interfaces/policestation-form.interface";

const policeStationsUrlApi = environment.policeStationsUrlApi;
const policeStationsDevicesUrlApi = environment.policeStationsDevicesUrlApi;

@Injectable()
export class PoliceStationService {
  public user: PoliceStationForm;

  constructor(private http: HttpClient) {}

  getPoliceStations() {
    return this.http
      .request("GET", `${policeStationsUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getPoliceStationById(id: number) {
    return this.http
      .request("GET", `${policeStationsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getPoliceStationDevices(idPoliceStation: number) {
    return this.http
      .request("GET", `${policeStationsDevicesUrlApi}/` + idPoliceStation, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getPoliceStationByUser(idUser: number) {
    //TO DO
    return this.http
      .request("GET", `${policeStationsUrlApi}/` + idUser, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  updatePoliceStationById(id: number, clientModel: PoliceStationForm) {
    const body = clientModel;
    return this.http
      .request("PUT", `${policeStationsUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createPoliceStation(clientModel: PoliceStationForm) {
    const body = clientModel;
    return this.http
      .request("POST", `${policeStationsUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  deletePoliceStationById(id: number) {
    return this.http
      .request("DELETE", `${policeStationsUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  assignDevicesToPoliceStation(idPoliceStation: number, arrayDevicesSelected) {
    const body = { id_devices: arrayDevicesSelected };
    return this.http
      .request("POST", `${policeStationsDevicesUrlApi}/` + idPoliceStation, {
        body,
      })
      .pipe(map((resp: any) => resp));
  }
}
